<template>
<div class="chapter">
<div class="inner_page">
<table style="margin-top:5em;">
<tbody>
<tr>
<td align="left" valign="top"><img alt="inline" src="images/pipe.jpg"/></td>
<td align="center" style="padding-right:1.5em;padding-left:1.5em;" valign="top">
<p class="part-lab"><a id="page_xvi"></a><a id="page_1">Section 1</a></p>
<h2 class="part" id="part01"><a id="page_1">A LIFE OF PURPOSE THROUGH PROSPERITY</a></h2>
</td>
<td align="left" valign="top"><img alt="inline" src="images/pipe.jpg"/></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?71b2c7ac